export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4689.a8168d77.jpg";